import { useTranslation } from 'react-i18next'
import type { ApplyChannel } from '@/components/v2/tools/amazon-listing/RemakeApply/RemakeApplyChannelPicker'

interface ChannelFilterSelectorProps {
  channels: ApplyChannel[]
  activeId: string
  onChange: (id: string) => void
}

/**
 * Channel filter: pill buttons (role=group + aria-pressed toggles) rendered in
 * a horizontally scrollable strip. No dropdown fallback — many channels just
 * scroll sideways so users can still see/access every pill.
 */
export function ChannelFilterSelector({
  channels,
  activeId,
  onChange,
}: ChannelFilterSelectorProps) {
  const { t } = useTranslation()

  return (
    <div
      role="group"
      aria-label={t('addToProduct.channelPicker.label')}
      className="flex gap-2 overflow-x-auto whitespace-nowrap"
    >
      {channels.map((c) => {
        const active = activeId === c.id
        return (
          <button
            key={c.id}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(c.id)}
            className={[
              'shrink-0 px-3 py-1.5 rounded-full text-xs font-medium border transition-colors',
              active
                ? 'bg-orange-500 text-white border-orange-500'
                : 'bg-white dark:bg-neutral-900 text-neutral-700 dark:text-neutral-300 border-neutral-200 dark:border-neutral-800 hover:border-orange-300',
            ].join(' ')}
          >
            {c.name}
          </button>
        )
      })}
    </div>
  )
}
